export default __webpack_public_path__ + "static/newsthree-e71cecc7d22a77522f05cbd3315ae80d.png";